var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13 10H7","stroke":"#22202F","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Minus.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Minus;

Minus.default = Minus;
